<template>
  <div class="stage" ref="stage">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Stage from '@/scripts/Stage';

export default {
  name: 'Stage',

  data() {
    return {
      stage: null,
    };
  },

  mounted() {
    this.stage = new Stage(
      this.$refs.stage,
      this.$refs.canvas,
      this.$parent.$el.querySelector('.page'),
    );
    this.stage.load().then(() => {
      this.$eventHub.$emit('stage-loaded');
    });
    this.$eventHub.$on('apollo-init', () => this.stage.init());
  },
};
</script>

<style lang="scss" scoped>
.stage {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
}
</style>
